import { AxiosInstance } from "axios";

export abstract class BaseAPI {
    constructor(protected api: AxiosInstance) { }
}